// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/suit-spade.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'suit-spade',
  version: 'solid',
  paths: [
    {
      d: 'M3.492 13.407C3.492 8.96 8.074 7.541 12 2.99c3.925 4.551 8.508 5.97 8.508 10.419 0 2.753-2.21 4.36-4.303 4.36-1.723 0-3.263-1.272-3.915-2.443.048 1.203.244 2.438.817 3.354.544.87 1.515 1.6 2.531 1.847v.482H8.361v-.482c1.014-.248 1.988-.977 2.531-1.845.574-.918.77-2.153.817-3.356-.652 1.17-2.191 2.445-3.914 2.445-2.094 0-4.303-1.609-4.303-4.364',
    },
  ],
}
